<img
  (error)="src = defaultPath"
  [src]="src || ''"
  [alt]="airlineID || ''"
  [title]="title || ''"
>
